import {
  BaseQueryApi,
  BaseQueryFn,
  createApi,
} from '@reduxjs/toolkit/query/react';
import { apiRequestFailed, apiRequestSuccess } from './api.actions';
import { RequestConfig } from './api.types';
import { baseFetcher, BaseFetcherResult } from './apiStatelessJwt.saga';

const baseQueryWithConfig: BaseQueryFn<RequestConfig> = async (
  args: RequestConfig,
  api: BaseQueryApi,
) => {
  const { response, error, result, payload } = await baseFetcher({
    requestConfig: args,
    resourceId: '',
  });

  //per triggherare le robbe nel session.saga ma probabilmente lo sposteremo dentro il baseFetcher per rimuovere la dipendenza
  if (result === BaseFetcherResult.SUCCESS) {
    api.dispatch(
      apiRequestSuccess({
        ...payload,
        response: response?.data,
      }),
    );
  } else if (result === BaseFetcherResult.API_REQUEST_FAILED) {
    api.dispatch(apiRequestFailed({ ...payload, error: error as any }));
  }

  if (!response) {
    return { data: undefined, error: error ?? 'Unknown error' };
  }

  return { data: response.data, error: undefined };
};

export const api = createApi({
  reducerPath: 'RTK-API-REDUCER',
  baseQuery: baseQueryWithConfig,
  endpoints: () => ({}),
  catchSchemaFailure: (error, info) => {
    console.error(
      `RTK VALIDATION ERROR: Schema validation failed for endpoint [${info.endpoint}] with error: ${error.message}`,
    );
  },
});
